/* @flow */
import {cappedTotal} from '../../utils/resultsCountText';

import type {IntlShape} from 'react-intl';

type Props = {
    intl: IntlShape,
    resultsCount?: ?number
};

export default function seeResultsMessage({intl, resultsCount}: Props): string {
    let resultCount;
    let resultString;

    if (typeof resultsCount !== 'undefined' && resultsCount !== null) {
        resultCount = resultsCount < cappedTotal ? resultsCount : cappedTotal;
        resultString = resultsCount < cappedTotal ? 'lessThanCap' : '';
        resultString = resultCount === 1 ? 'one' : resultString;

        return intl.formatMessage(
            {
                id: 'seeResultsWithExactCount',
                defaultMessage:
                    '{resultString, select, one {See 1 Result} lessThanCap {See {resultCount} Results} other {See {resultCount}+ Results}}'
            },
            {resultCount, resultString}
        );
    }

    return intl.formatMessage({
        id: 'seeResults',
        defaultMessage: 'See Results'
    });
}
